import { baseThemeValues } from 'constants/common';

const labelFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 600,
};

const textFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '13px',
  fontWeight: 400,
};

export const copyLimitsTheme = {
  callout: {
    ...textFont,
    bg: 'palette.primary.10:0.6',
    borderColor: 'palette.primary.50',
    borderRadius: '8px',
    borderWidth: '1px',
    text: 'palette.tertiary.95',
  },
  dryRun: {
    divider: 'palette.tertiary.30',
    failed: {
      text: 'palette.error.60',
    },
    muted: {
      text: 'palette.tertiary.60',
    },
    toggle: {
      text: 'palette.primary.50',
    },
  },
  separator: 'palette.tertiary.30',
  subSection: {
    label: {
      ...labelFont,
      text: 'palette.tertiary.95',
    },
  },
  summary: {
    ...textFont,
    text: 'palette.tertiary.60',
  },
};
